<template>
  <div>
    <AuBreadcrumb :parent-name="$t('router.pages.dashboard')" />
    <div class="card referral-panel">
      <div class="title">
        {{ $t("myReferrals.title") }}
      </div>
      <div class="count">
        {{ $t("myReferrals.number") }}
        <AuSkeleton v-if="loading" />
        <span
          v-else
          class="value"
        >
          {{ totalItems }}
        </span>
      </div>
      <ProgressLoader
        v-if="loading"
        mode="indeterminate"
        color="#5AC396"
        size="150px"
      />
      <div v-else>
        <UTable
          :items="items"
          :columns="tableColumns"
        >
          <!-- Слот для колонки с суммой в default token -->
          <template #defaultTokenAmount="{ value }">
            <AuDecimalStatic
              :value="value"
              :decimal="defaultTokenDecimal"
              :show-addition="false"
            />
          </template>

          <!-- Слот для колонки с суммой в AUT -->
          <template #rwaAmount="{ value }">
            <AuDecimalStatic
              :value="value"
              :decimal="defaultAutDecimal"
              :show-addition="false"
            />
          </template>
        </UTable>

        <AuPagination
          v-if="totalItems > itemsPerPage"
          :total-items="totalItems"
          @pageChanged="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import AuDecimalStatic from "@/components/extended/AuDecimalStatic.vue";
import AuPagination from "@/components/extended/AuPagination.vue";
import AuSkeleton from "@/components/extended/AuSkeleton.vue";
import moment from "moment/moment";
import ProgressLoader from "@/loaders/progress-bar";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Referrals",
  components: {
    AuPagination,
    AuDecimalStatic,
    AuSkeleton,
    ProgressLoader,
    UTable
  },

  data() {
    return {
      loading: true,
      referral: [],
      page: 1,
      itemsPerPage: 30,
      totalItems: 0
    };
  },

  computed: {
    ...mapGetters({
      tokens: "tokens",
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      defaultAutMnemonic: "defaultToken/defaultAutMnemonic"
    }),

    defaultTokenDecimal() {
      return (
        this.tokens.find(
          (token) => token.mnemonicEng === this.defaultTokenMnemonic
        )?.decimals ?? 2
      );
    },

    defaultAutDecimal() {
      return (
        this.tokens.find(
          (token) => token.mnemonicEng === this.defaultAutMnemonic
        )?.decimals ?? 2
      );
    },

    // Колонки для UTable
    tableColumns() {
      return [
        {
          property: "date",
          header: this.$t("myReferrals.registered"),
          align: "left"
        },
        {
          property: "email",
          header: this.$t("referral.email"),
          align: "left"
        },
        {
          property: "level",
          header: this.$t("myReferrals.level") + " / " + this.$t("myReferrals.source"),
          align: "center"
        },
        {
          property: "defaultTokenAmount",
          header: this.$t("myReferrals.amount") + " " + this.defaultTokenMnemonic,
          align: "center"
        },
        {
          property: "rwaAmount",
          header: this.$t("myReferrals.amount") + " " + this.defaultAutMnemonic,
          align: "center"
        }
      ];
    },

    // Форматирование данных для таблицы
    items() {
      return _.map(this.referral, (item, index) => {
        // Создаем уникальный ID для каждой строки
        const itemId = item.id || `referral-${index}-${Date.now()}`;

        return {
          id: itemId,
          date: moment(item?.createdAt).format("DD.MM.YYYY"),
          email: item?.email || "-",
          level: item?.refSource ? item?.level + " / " + item?.refSource : (item?.level || "-"),
          defaultTokenAmount: item?.defaultTokenAmount == 0 ? "-" : item?.defaultTokenAmount,
          rwaAmount: item?.rwaAmount == 0 ? "-" : item?.rwaAmount
        };
      });
    }
  },

  async mounted() {
    await this.getData();
  },

  methods: {
    ...mapActions({
      getReferrals: "getReferrals"
    }),

    async changePage(actualPage) {
      this.page = actualPage;
      await this.getData();
    },

    async getData() {
      this.loading = true;
      try {
        const resp = await this.getReferrals({
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          pagination: true
        });
        this.referral = resp.data;
        this.totalItems = resp.totalItems;
      }
      catch (e) {
        console.error(e);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.referral-panel {
  padding: 20px;

  .title {
    font-size: 24px;
    line-height: 1.1em;
  }

  .count {
    display: flex;
    gap: 3px;
    align-items: center;

    font-weight: 450;
    font-size: 12px;
    color: var(--color-60);
    margin-bottom: 20px;
  }

  .value {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-60);
  }
}
</style>